// Base API URL - dev
export const STRIPE_API_KEY = process.env.STRIPE_API_KEY
    ? process.env.STRIPE_API_KEY
    : 'pk_test_rDgsjkQxnBaKqDYInC5Y6lmr'; //'pk_test_V1xavBb6tYGgsrEwQp4va1Tk00VGDZenG9';
